module.exports = __webpack_public_path__ + "48f00bd6872b2161c6abff53b3887b86.jpg";